"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _class, _class2, _temp;
var styles = {
  componentId: 'dKjcB',
  template: function template(theme) {
    return "\n\n.dKjcB_bGBk{align-items:center;display:flex;font-family:".concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";width:100%}\n\n.dKjcB_fKwc[value]{-moz-appearance:none;-webkit-appearance:none;appearance:none;border:none;box-sizing:border-box;flex:1;width:auto}\n\n.dKjcB_fKwc[value]::-webkit-progress-value{background:linear-gradient(90deg,").concat(theme.meterColorStart || 'inherit', " 0%,").concat(theme.meterColorEnd || 'inherit', ")}\n\n.dKjcB_fKwc[value]::-moz-progress-bar{background:linear-gradient(90deg,").concat(theme.meterColorStart || 'inherit', " 0%,").concat(theme.meterColorEnd || 'inherit', ")}\n\n.dKjcB_fKwc[value]::-ms-fill{background:linear-gradient(90deg,").concat(theme.meterColorStart || 'inherit', " 0%,").concat(theme.meterColorEnd || 'inherit', ");border:none}\n\n.dKjcB_fqzO{-webkit-padding-start:").concat(theme.valuePadding || 'inherit', ";box-sizing:border-box;flex:0 0 5.625rem;line-height:1;padding-inline-start:").concat(theme.valuePadding || 'inherit', "}\n\n[dir=ltr] .dKjcB_fqzO{padding-left:").concat(theme.valuePadding || 'inherit', "}\n\n[dir=rtl] .dKjcB_fqzO{padding-right:").concat(theme.valuePadding || 'inherit', "}\n\n.dKjcB_bpmu{-webkit-margin-end:0.1875rem;-webkit-margin-start:0.1875rem;margin-inline-end:0.1875rem;margin-inline-start:0.1875rem}\n\n[dir=ltr] .dKjcB_bpmu{margin-left:0.1875rem;margin-right:0.1875rem}\n\n[dir=rtl] .dKjcB_bpmu{margin-left:0.1875rem;margin-right:0.1875rem}\n\n.dKjcB_dfBC .dKjcB_fKwc[value]{height:").concat(theme.xSmallHeight || 'inherit', "}\n\n.dKjcB_dfBC .dKjcB_fqzO{font-size:").concat(theme.xSmallValueFontSize || 'inherit', "}\n\n.dKjcB_doqw .dKjcB_fKwc[value]{height:1.125rem}\n\n.dKjcB_doqw .dKjcB_fqzO{font-size:").concat(theme.smallValueFontSize || 'inherit', "}\n\n.dKjcB_ycrn .dKjcB_fKwc[value]{height:").concat(theme.mediumHeight || 'inherit', "}\n\n.dKjcB_ycrn .dKjcB_fqzO{font-size:").concat(theme.mediumValueFontSize || 'inherit', "}\n\n.dKjcB_cMDj .dKjcB_fKwc[value]{height:").concat(theme.largeHeight || 'inherit', "}\n\n.dKjcB_cMDj .dKjcB_fqzO{font-size:").concat(theme.largeValueFontSize || 'inherit', "}\n\n.dKjcB_ddES .dKjcB_fKwc[value]{background-color:").concat(theme.trackColor || 'inherit', "}\n\n.dKjcB_ddES .dKjcB_fKwc[value]::-webkit-progress-bar{background-color:").concat(theme.trackColor || 'inherit', "}\n\n.dKjcB_ddES .dKjcB_fqzO{color:").concat(theme.color || 'inherit', "}\n\n.dKjcB_enfx .dKjcB_fKwc[value]{background-color:").concat(theme.inverseTrackColor || 'inherit', "}\n\n.dKjcB_enfx .dKjcB_fKwc[value]::-webkit-progress-bar{background-color:").concat(theme.inverseTrackColor || 'inherit', "}\n\n.dKjcB_enfx .dKjcB_fqzO{color:").concat(theme.inverseColor || 'inherit', "}\n\n.dKjcB_fFDe .dKjcB_fKwc[value]::-webkit-progress-value{background:linear-gradient(90deg,").concat(theme.doneMeterColorStart || 'inherit', " 0%,").concat(theme.doneMeterColorEnd || 'inherit', ")}\n\n.dKjcB_fFDe .dKjcB_fKwc[value]::-moz-progress-bar{background:linear-gradient(90deg,").concat(theme.doneMeterColorStart || 'inherit', " 0%,").concat(theme.doneMeterColorEnd || 'inherit', ")}\n\n.dKjcB_fFDe .dKjcB_fKwc[value]::-ms-fill{background:linear-gradient(90deg,").concat(theme.doneMeterColorStart || 'inherit', " 0%,").concat(theme.doneMeterColorEnd || 'inherit', ")}");
  },
  'root': 'dKjcB_bGBk',
  'bar': 'dKjcB_fKwc',
  'value': 'dKjcB_fqzO',
  'slash': 'dKjcB_bpmu',
  'x-small': 'dKjcB_dfBC',
  'small': 'dKjcB_doqw',
  'medium': 'dKjcB_ycrn',
  'large': 'dKjcB_cMDj',
  'default': 'dKjcB_ddES',
  'inverse': 'dKjcB_enfx',
  'done': 'dKjcB_fFDe'
};
var ProgressBar = (
/**
---
parent: Progress
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProgressBar, _Component);
  function ProgressBar() {
    (0, _classCallCheck2.default)(this, ProgressBar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProgressBar).apply(this, arguments));
  }
  (0, _createClass2.default)(ProgressBar, [{
    key: "render",
    value: function render() {
      var _classes;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[this.props.size], true), (0, _defineProperty2.default)(_classes, styles[this.props.variant], true), (0, _defineProperty2.default)(_classes, styles.done, this.props.successColor && this.props.valueNow / this.props.valueMax >= 1), _classes);
      var _this$props = this.props,
        formatDisplayedValue = _this$props.formatDisplayedValue,
        formatValueText = _this$props.formatValueText,
        valueNow = _this$props.valueNow,
        valueMax = _this$props.valueMax,
        label = _this$props.label;
      var valueText = formatValueText(valueNow, valueMax);
      var value = typeof formatDisplayedValue === 'function' && formatDisplayedValue(valueNow, valueMax);
      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, ProgressBar.propTypes, ['animateOnMount']), ProgressBar);
      /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-noninteractive-element-to-interactive-role */

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        as: this.props.as,
        className: (0, _classnames.default)(classes),
        margin: this.props.margin,
        elementRef: this.props.elementRef
      }), _react.default.createElement("progress", {
        className: styles.bar,
        max: valueMax,
        value: valueNow,
        role: "progressbar",
        "aria-valuetext": valueText,
        "aria-valuenow": valueNow,
        "aria-valuemax": valueMax,
        "aria-label": label
      }), value && _react.default.createElement("span", {
        className: styles.value,
        "aria-hidden": "true"
      }, value));
      /* eslint-enable jsx-a11y/no-redundant-roles, jsx-a11y/no-noninteractive-element-to-interactive-role */
    }
  }]);
  ProgressBar.displayName = "ProgressBar";
  return ProgressBar;
}(_react.Component), _class2.propTypes = {
  /**
  * A label is required for accessibility
  */
  label: _propTypes.default.string.isRequired,
  /**
  * Different-sized progress bars and circles
  */
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium', 'large']),
  /**
  * Maximum value (defaults to 100)
  */
  valueMax: _propTypes.default.number,
  /**
  * Receives the progress of the event
  */
  valueNow: _propTypes.default.number,
  /**
  * A function that returns the current value formatted for screen readers
  */
  formatValueText: _propTypes.default.func,
  /**
  * A function to format the displayed value. If null the value will not display.
  */
  formatDisplayedValue: _propTypes.default.func,
  /**
  * The bar changes to your theme's success color when complete
  */
  successColor: _propTypes.default.bool,
  /**
  * Choose either a progress bar or circle. The `-inverse` variants are for
  * when you need the Progress component to appear on inverse backgrounds
  */
  variant: _propTypes.default.oneOf(['default', 'inverse']),
  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  elementRef: _propTypes.default.func,
  as: _propTypes.default.elementType
}, _class2.defaultProps = {
  formatValueText: function formatValueText(valueNow, valueMax) {
    return "".concat(valueNow, " / ").concat(valueMax);
  },
  size: 'medium',
  valueMax: 100,
  valueNow: 0,
  variant: 'default',
  successColor: true,
  as: 'div',
  formatDisplayedValue: void 0,
  margin: void 0,
  elementRef: void 0
}, _temp)) || _class);
exports.default = ProgressBar;